module.exports = __webpack_public_path__ + "img/bg_cybersafe.ae68c9e0.png";